<template>
  <div
    class="modal"
    @click="hideModel(0)"
    :class="{'modal-show':show}"
  >
    <div
      class="box"
      @click.stop="hideModel(1)"
    >
      <slot></slot>
    </div>
  </div>
</template>
<script>
// 一级模态窗
export default {
  name: 'fadeLeftModal',
  props: ['show'],
  data() {
    return {
    }
  },
  methods: {
    hideModel(val) {
      this.$emit('hideModel', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 901;
  & .box {
    max-height: 100%;
    max-width: 100%;
    color: #000;
    position: absolute;
    top: 60px;
    right: -740px;
    transform: translateX(0px);
    transition: all 0.3s;
    bottom: 0;
    overflow: auto;
    background-color: rgba(247, 247, 247, 1);
  }
}

// 模态窗显示样式
.modal-show {
  opacity: 1;
  // display: block;
  visibility: visible;
  & .box {
    transform: translateX(-740px);
  }
}
</style>